import { render, staticRenderFns } from "./aPort.vue?vue&type=template&id=4f7ae938&scoped=true&"
import script from "./aPort.vue?vue&type=script&lang=js&"
export * from "./aPort.vue?vue&type=script&lang=js&"
import style0 from "./aPort.vue?vue&type=style&index=0&id=4f7ae938&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f7ae938",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4f7ae938')) {
      api.createRecord('4f7ae938', component.options)
    } else {
      api.reload('4f7ae938', component.options)
    }
    module.hot.accept("./aPort.vue?vue&type=template&id=4f7ae938&scoped=true&", function () {
      api.rerender('4f7ae938', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/Information/components/aPort.vue"
export default component.exports